/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Comparison_Agerating1Inputs */

const id_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringkat Usia:`)
};

const ms_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penarafan Umur:`)
};

const da_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aldersvurdering:`)
};

const de_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altersfreigabe:`)
};

const en_us2_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age Rating:`)
};

const es_es2_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificación por edad:`)
};

const es_mx2_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificación por edad:`)
};

const fil_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating ng Edad:`)
};

const fr_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classification :`)
};

const it_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificazione età:`)
};

const hu_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korhatár besorolás:`)
};

const nl_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leeftijdsclassificatie:`)
};

const no_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aldersvurdering:`)
};

const pl_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasyfikacja wiekowa:`)
};

const pt_br2_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age Rating`)
};

const pt_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação etária:`)
};

const ro_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificare de vârstă:`)
};

const fi_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikäraja:`)
};

const sv_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åldersklassificering:`)
};

const vi_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xếp hạng độ tuổi:`)
};

const tr_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaş Sınırı:`)
};

const cs_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Věkové hodnocení:`)
};

const bg_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Възрастово ограничение:`)
};

const ru_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возрастной рейтинг:`)
};

const uk_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Віковий рейтинг:`)
};

const ar_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التصنيف العمري:`)
};

const hi_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयु रेटिंग:`)
};

const th_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรตอายุ:`)
};

const ja_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年齢レーティング：`)
};

const zh_cn2_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age Rating`)
};

const zh_hant1_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age Rating`)
};

const ko_components_comparison_agerating1 = /** @type {(inputs: Components_Comparison_Agerating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age Rating`)
};

/**
* | output |
* | --- |
* | "Age Rating:" |
*
* @param {Components_Comparison_Agerating1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_comparison_agerating1 = /** @type {((inputs?: Components_Comparison_Agerating1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Comparison_Agerating1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_comparison_agerating1(inputs)
	if (locale === "ms") return ms_components_comparison_agerating1(inputs)
	if (locale === "da") return da_components_comparison_agerating1(inputs)
	if (locale === "de") return de_components_comparison_agerating1(inputs)
	if (locale === "en-US") return en_us2_components_comparison_agerating1(inputs)
	if (locale === "es-ES") return es_es2_components_comparison_agerating1(inputs)
	if (locale === "es-MX") return es_mx2_components_comparison_agerating1(inputs)
	if (locale === "fil") return fil_components_comparison_agerating1(inputs)
	if (locale === "fr") return fr_components_comparison_agerating1(inputs)
	if (locale === "it") return it_components_comparison_agerating1(inputs)
	if (locale === "hu") return hu_components_comparison_agerating1(inputs)
	if (locale === "nl") return nl_components_comparison_agerating1(inputs)
	if (locale === "no") return no_components_comparison_agerating1(inputs)
	if (locale === "pl") return pl_components_comparison_agerating1(inputs)
	if (locale === "pt-BR") return pt_br2_components_comparison_agerating1(inputs)
	if (locale === "pt") return pt_components_comparison_agerating1(inputs)
	if (locale === "ro") return ro_components_comparison_agerating1(inputs)
	if (locale === "fi") return fi_components_comparison_agerating1(inputs)
	if (locale === "sv") return sv_components_comparison_agerating1(inputs)
	if (locale === "vi") return vi_components_comparison_agerating1(inputs)
	if (locale === "tr") return tr_components_comparison_agerating1(inputs)
	if (locale === "cs") return cs_components_comparison_agerating1(inputs)
	if (locale === "bg") return bg_components_comparison_agerating1(inputs)
	if (locale === "ru") return ru_components_comparison_agerating1(inputs)
	if (locale === "uk") return uk_components_comparison_agerating1(inputs)
	if (locale === "ar") return ar_components_comparison_agerating1(inputs)
	if (locale === "hi") return hi_components_comparison_agerating1(inputs)
	if (locale === "th") return th_components_comparison_agerating1(inputs)
	if (locale === "ja") return ja_components_comparison_agerating1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_comparison_agerating1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_comparison_agerating1(inputs)
	return ko_components_comparison_agerating1(inputs)
});
export { components_comparison_agerating1 as "components.comparison.ageRating" }